<style>
    .ivu-table .demo-table-info-row td{
        color: red;
    }
    .custom-group-switch {
        margin-right: -2px;
        z-index: 10;
        border-radius: 0;
    }
    .custom-group-switch .ivu-switch-large{
        height: 99%;
        border-radius: 0;
        padding-top: 4px;
        width: 70px;
    }
    .custom-group-switch .ivu-switch-inner{
        margin-left: 4px;
    }
    .custom-group-switch .ivu-switch-large:after{
        margin: 4px 0 0 4px;
    }
</style>

<template>
  <div>
    <Card>
        <p slot="title"> Giro Pending </p>
        <Row type="flex" justify="space-between">
            <Col span="6">
                <ButtonGroup class="custom-group-parent">
                    <Button class="custom-group">Tgl. Terima Giro</Button>
                    <DatePicker
                        v-model="giroDateSelected"
                        type="daterange"
                        placeholder="Select date"
                        style="width: 180px"
                        @on-change="getReceivableGiroList()"/>
                </ButtonGroup>
            </Col>
            <Col span="6">
                <ButtonGroup class="custom-group-parent">
                    <Button class="custom-group">Tgl. Jatuh Tempo</Button>
                    <DatePicker
                        v-model="paymentDateSelected"
                        type="daterange"
                        placeholder="Select date"
                        style="width: 180px"
                        @on-change="getReceivableGiroList()"/>
                </ButtonGroup>
            </Col>
            <Col span="5" style="display: flex;">
                <div class="custom-group-switch">
                    <i-switch size="large" v-model="isGroupFilter">
                        <span slot="open">Group</span>
                        <span slot="close">Mark</span>
                    </i-switch>
                </div>
                <transition name="move-right">
                    <Select
                        clearable
                        filterable
                        placeholder="Select Marking"
                        v-show="isGroupFilter == false"
                        v-model="markingHeaderIdSelected"
                        :remote-method="getMarkingByCode"
                        :loading="isLoadingGetMarking"
                        @on-change="getReceivableGiroList()">
                        <Option v-for="option in optionMarkings"
                            :value="option.value"
                            :key="option.value">{{option.label}}</Option>
                    </Select>
                </transition>

                <transition name="move-left">
                    <Select
                        clearable
                        filterable
                        placeholder="Select Group Name"
                        v-show="isGroupFilter == true"
                        v-model="markingGroupIdSelected"
                        :remote-method="getGroupMarkingByCode"
                        :loading="isLoadingGetMarking"
                        @on-change="getReceivableGiroList()">
                        <Option v-for="option in optionGroupMarkings"
                            :value="option.value"
                            :key="option.value">{{option.label}}</Option>
                    </Select>
                </transition>
            </Col>
            <Col span="6">
                <Spin size="large" v-show="isLoadingGiroList"></Spin>
            </Col>
        </Row>
        <br>
        <Card>
            <Alert type="info" show-icon v-show="totalGiro != 0"> Total Giro = {{ totalGiro }} lembar</Alert>
            <Alert type="success" show-icon v-show="totalGiro != 0"> Total Nominal = Rp {{ totalNominal | numberFormatted }}</Alert>
            <Table :row-class-name="rowClassName" :columns="columnsDataTable" :data="receivableGiroData"></Table>
        </Card>
    </Card>

    <!-- Modal confirm update list -->
    <Modal v-model="isModalConfirm" title="Konfirmasi" ok-text="Ya" cancel-text="Tidak" @on-ok="updateGiroList" @on-cancel="cancelUpdateGiroList">
        <p>{{ confirmationMessage }}</p>
    </Modal>

    <!-- Modal show history -->
    <Modal v-model="isModalHistory" title="History">
        <Table :columns="columnsHistory" :data="dataHistory"></Table>
    </Modal>
  </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import {Money} from 'v-money'

const numeral = require('numeral');

export default {
    components : { Money },
    data () {
        return {
            money: {
              decimal: ',',
              thousands: '.',
              prefix: '',
              suffix: '',
              precision: 0,
              masked: false
            },
            giroDateSelected : [],
            paymentDateSelected : [],
            optionMarkings : [],
            optionGroupMarkings : [],
            markingIdSelected: null,
            isLoadingGetMarking: false,
            isLoadingGiroList: false,
            markingHeaderIdSelected : null,
            markingGroupIdSelected : null,
            isGroupFilter: false,

            columnsDataTable: [
                {
                    title: 'Marking',
                    key: 'marking',
                    width: 150,
                },
                {
                    title: 'Marking Grup',
                    key: 'markingGroup',
                    width: 150,
                },
                {
                    title: 'Tgl. Terima Giro',
                    key: 'giroDate',
                    width: 150,
                },
                {
                    title: 'Tgl. Jatuh Tempo',
                    key: 'paymentDate',
                    width: 150,
                },
                {
                    title: 'Nomor Giro',
                    key: 'giroNumber',
                    width: 150,
                },
                {
                    title: 'Nominal Giro',
                    key: 'giroNominal',
                    width: 150,
                },
                {
                    title: 'Bank',
                    key: 'accountName',
                    width: 150,
                },
                {
                    title: 'Tgl. Mundur',
                    key: 'dueDate',
                    width: 150,
                },
                {
                    title: 'Aksi',
                    key: 'isCancel',
                    width: 200,
                    align: 'center',
                    fixed: 'right',
                    render: (h, params) => {
                        const { row } = params
                        let setDisable = row.isCancel == 1 ? true : false
                        let setDisableHistory = (row.giroHistory == undefined || row.giroHistory.length > 0) ? false : true

                        // Handle unclearing as hapus payment terlebih dahulu sebelum dibatalkan
                        if (row.isClearing == 1) {
                            setDisable = true
                        }

                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                    disabled: setDisable
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalConfirm('isCancel', true, params.index)
                                    }
                                }
                            }, 'Batalkan'),
                            h('Button', {
                                props: {
                                    type: 'warning',
                                    size: 'small',
                                    disabled: setDisableHistory
                                },
                                on: {
                                    click: () => {
                                        this.showModalHistory(params.index)
                                    }
                                }
                            }, 'History')
                        ])
                    }
                }
            ],

            receivableGiroData: [],
            isModalConfirm: false,
            isGroupEdit: false,
            confirmationMessage: null,
            varType: null,
            varValue: null,
            varIndex: null,
            isModalHistory: false,
            columnsHistory: [
                {
                    title: 'Pembuat',
                    key: 'createdBy',
                },
                {
                    title: 'Tanggal Ubah',
                    key: 'createdAt',
                },
                {
                    title: 'Tanggal Jatuh Tempo',
                    key: 'dueDate',
                },
            ],
            dataHistory: [],

            totalGiro: 0,
            totalNominal: 0
        }
    },
    methods: {
        rowClassName (row, index) {
            if (row.isCancel) {
                return 'demo-table-info-row';
            }

            return '';
        },
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        getMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '' && (this.isGroupAdd == false || this.isGroupFilter == false)) {
                    this.isLoadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.searchSelectSubbranch || null
                    })
                    .then(response => {
                        this.isLoadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getGroupMarkingByCode:  _.debounce(
            function (query) {
                if (query && query !== '' && (this.isGroupAdd || this.isGroupFilter)) {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('markingGroup/getByCode', {
                        groupName: query
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        console.log({data});
                        const list = data.map(item => {
                            return {
                                value: item.id,
                                label: item.code
                            };
                        });
                        this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        console.info(this.optionGroupMarkings)
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),
        getReceivableGiroList: function(){
            let parent = this;
            let startGiroDate = null;
            let endGiroDate = null;
            let startPaymentDate = null;
            let endPaymentDate = null;

            // set is group & null marking
            if (this.isGroupFilter) {
              this.markingHeaderIdSelected = null;
            }
            // set is marking & null group marking
            else {
                this.markingGroupIdSelected = null;
            }

            // handle giro date - tanggal terima giro
            if(this.giroDateSelected[0] != "" && this.giroDateSelected[0] != null) {
                startGiroDate = moment(this.giroDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endGiroDate = moment(this.giroDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            // handle payment date / tanggal jatuh tempo
            if(this.paymentDateSelected[0] != "" && this.paymentDateSelected[0] != null) {
                startPaymentDate = moment(this.paymentDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endPaymentDate = moment(this.paymentDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            let payload = {
                isPending: true,
                startGiroDate: startGiroDate,
                endGiroDate: endGiroDate,
                startPaymentDate: startPaymentDate,
                endPaymentDate: endPaymentDate,
                markingHeaderId: this.markingHeaderIdSelected,
                markingGroupId: this.markingGroupIdSelected
            }

            console.info({payload})
            this.isLoadingGiroList = true;
            HTTP.post('giro/search', payload)
            .then(response => {
                let receivableGiro = []

                // reset calculate total giro & total nominal
                parent.totalGiro = 0
                parent.totalNominal = 0

                _.forEach(response.data, function(value, index) {
                    let giroId = value.id
                    let giroDate = parent.showDateFormatted(value.giroDate)
                    let giroNumber = value.giroNumber
                    let giroNominal = "Rp. " + numeral(value.giroNominal).format('0,0')
                    let paymentDate = parent.showDateFormatted(value.paymentDate)
                    let accountName = value.bank_account != null ? value.bank_account.accountName : ''
                    let dueDate = (value.dueDate != null && value.dueDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.dueDate) : '-'
                    let isClearing = value.isClearing
                    let isCancel = value.isCancel
                    let marking = value.marking_header != null ? value.marking_header.markingheadercode : ''
                    let markingGroup = value.marking_group != null ? value.marking_group.code : ''
                    let markingHeaderCode = null

                    if (value.marking_header != null) {
                        markingHeaderCode = value.marking_header.markingheadercode
                    } else if (value.marking_group != null) {
                        markingHeaderCode = value.marking_group.code
                    }

                    let rGiro = {
                        marking : marking,
                        markingGroup : markingGroup,
                        markingHeaderCode : markingHeaderCode,
                        giroId : giroId,
                        giroDate : giroDate,
                        giroNumber : giroNumber,
                        giroNominal: giroNominal,
                        paymentDate: paymentDate,
                        accountName: accountName,
                        dueDate: dueDate,
                        isClearing: isClearing,
                        isCancel: isCancel
                    }
                    receivableGiro.push(rGiro);

                    // calculate total giro & total nominal
                    parent.totalGiro++
                    parent.totalNominal += value.giroNominal
                });

                this.receivableGiroData = receivableGiro;
                this.componentKey += 1; // re-render compononent handsontable
                this.isLoadingGiroList = false;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });
        },
        showModalConfirm: function(type, value, index){
            this.isModalConfirm = true
            this.varType = type
            this.varValue = value
            this.varIndex = index

            if (type == 'isCancel') {
                this.confirmationMessage = 'Apakah anda yakin ingin membatalkan giro ?'
            } else {
                return false
            }
        },
        updateGiroList: function(){
            this.$Loading.start();

            let rowData = this.receivableGiroData[this.varIndex]
            let tempIsDueDate = ''
            let tempIsClearing = ''
            let tempIsCancel = ''
            let successMsg = ''

            if (this.varType == 'isCancel') {
                tempIsDueDate = rowData.dueDate
                tempIsClearing = rowData.isClearing
                tempIsCancel = this.varValue
                successMsg = 'Giro berhasil dibatalkan !'
            } else {
                return false
            }

            let payload = {
                giroId: rowData.giroId,
                dueDate: moment(tempIsDueDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                isClearing: tempIsClearing,
                isCancel: tempIsCancel
            }

            console.log({payload});

            HTTP
            .post('giro/update', payload)
            .then(response => {
                this.isModalConfirm = false;
                this.$Loading.finish();
                this.$Message.success(successMsg);
                this.getReceivableGiroList();
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
        },
        cancelUpdateGiroList: function() {
            this.getReceivableGiroList();
        },
        showModalHistory: function(index){
            this.isModalHistory = true
            let parent = this
            let rowData = this.receivableGiroData[index]
            let histories = []

            _.forEach(rowData.giroHistory, function(value, index) {
                let createdBy = value.createdBy
                let createdAt = value.createdAt
                let dueDate = (value.dueDate != null && value.dueDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.dueDate) : '-'

                let history = {
                    createdBy : createdBy,
                    createdAt : createdAt,
                    dueDate : dueDate
                }
                histories.push(history);
            });

            this.dataHistory = histories;
        },

    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        }
    },
    mounted() {
        this.getReceivableGiroList()
        this.$Loading.config({
            color: '#fff',
            failedColor: '#f0ad4e',
            height: 10
        });
    }
}

</script>



// WEBPACK FOOTER //
// GiroPending.vue?0c66f18c